export default {
  'importIssueFiles.errorUpload':
    'File upload with import number <%= fileName %> has failed. Please check Failed Imports',
  'importIssueFiles.uploadWarning':
    'Cutoff time is <%= cutOffTime %> ET. Cutoff time has expired. All imported items will be processed the next business day.',

  'importIssueFiles.format.commaSeparated': 'Comma separated import format',
  'importIssueFiles.format.fixedRecord': 'Fixed record import format',

  'importIssueFiles.importSizeError': 'The file that you are trying to upload exceeds limit.',

  'importIssueFiles.allFiles': 'All Files',
  'importIssueFiles.upload.header': 'Import Issue File',
  'importIssueFiles.upload.screenReaderHeader': 'View Import Issue File',
  'importIssueFiles.upload.success': 'File has been successfully uploaded',
  'importIssueFiles.upload.text1': 'Drag file here or',
  'importIssueFiles.upload.text2': 'from your computer.',
  'importIssueFiles.upload.restrictions': '1 file maximum. 500 records per file maximum',
  'importIssueFiles.upload.restrictions2': '1 file maximum. 10,000 records per file maximum',
  'importIssueFiles.upload.ach.restrictions': '1 file maximum. 50000 records per file maximum',
  'importIssueFiles.upload.decimal.disabled':
    'Any dollar value specified in your import file that does not include a decimal will be imported as a whole dollar amount. \nFor example, a value of 1234 will be imported as $1234.00',
  'importIssueFiles.upload.decimal.enabled':
    'Any dollar value specified in your import file that does not include a decimal will be imported with an implied decimal – two positions from the rightmost digit.  \nFor example, a value of 1234 will be imported as $12.34.'
};
